<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.title"
              clearable
              placeholder="所有功能"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <el-card
      class="card"
      :body-style="{ padding: '10px' }"
      v-for="o in list"
      :key="o"
      shadow="hover"
      @click="go(o)"
    >
      <img :src="o.basic.avatar" class="image" />
      <div class="card-title">
        <span>{{ o.title }}</span>
      </div>
    </el-card>

    <!-- <edit ref="edit" @fetch-data="fetchData" /> -->
    <!-- <detail ref="detail" @fetch-data="fetchData" /> -->
  </div>
</template>

<script>
import moment from 'moment'
import { findAppWidgetList } from '@/api/widget'
// import Detail from './detail.vue'
export default {
  name: 'AppList',
  components: {},
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        mode: 2,
        page: 1,
        size: 10,
        scope: 1,
      },
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (to.path == '/widget') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    edit(row) {
      this.$refs['edit'].showEdit(row)
    },
    detail(row) {
      this.$refs['detail'].showDetail(row)
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const ret = await findAppWidgetList(this.queryForm)
      this.list = ret.list.map(e => e.widget)
      this.listLoading = false
    },
    go(widget) {
      this.$router.push(widget.basic.path)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  width: 160px !important;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.card-title {
  text-align: center;
  padding: 14px;
  font-size: 17px;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  padding: 0;
  min-height: auto;
}

.image {
  width: 80px;
  display: block;
  margin: 0 auto;
  margin-top: 10px;
}
</style>
